export default __webpack_public_path__ + "static/media/Split_Leg_Position_Male.f9907093.png";